import React from 'react';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import IconButton from '@mui/material/IconButton';
import classNames from 'classnames';
import CustomDialog from '@/components/common/CustomDialog';
import translate from '@/lib/intl/translate';

type BioCellProps = {
  biography?: string;
};

function BioCell({ biography }: BioCellProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isHovered, setIsHovered] = React.useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleMouseOver = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return biography ? (
    <div
      className="flex items-center"
      data-testid="bio-column"
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      onFocus={handleMouseOver}
      onBlur={handleMouseLeave}
    >
      <div className="grow truncate">{biography}</div>
      <IconButton
        onClick={handleOpen}
        size="small"
        className={classNames('ml-1 shrink-0 grow-0', {
          invisible: !isHovered,
        })}
        aria-label={translate('SHOW_MORE')}
        aria-hidden={!isHovered}
      >
        <OpenInFullIcon className="h-4 w-4" />
      </IconButton>
      <CustomDialog
        open={isOpen}
        onClose={handleClose}
        showDialogActions={false}
        dialogHeader={translate('BIOGRAPHY_LABEL')}
        PaperProps={{
          classes: {
            root: 'w-full',
          },
        }}
      >
        <div className="whitespace-pre-line">{biography}</div>
      </CustomDialog>
    </div>
  ) : null;
}

export default BioCell;
